import { VOLOP_IMPORTED_TYPE_MAP } from './volopImportedTypeMap';

export const VOLOP_SOURCES = {
  ...VOLOP_IMPORTED_TYPE_MAP,
  IDEALIST: 'Idealist',
};

export const VOLOP_SOURCE_RADIO_OR_SELECT_OPTIONS = () =>
  Object.entries(VOLOP_SOURCES)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key as keyof typeof VOLOP_SOURCES,
      label: value,
    }));

export const VOLOP_SOURCE_CHECKBOX_OPTIONS = () =>
  Object.entries(VOLOP_SOURCES)
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key as keyof typeof VOLOP_SOURCES,
      label: value,
    }));
